import { registerNodeType } from '../../registry'
import { ICONIFY } from '../../../../../Constants/iconify'
import DropdownTextfieldNode from './DropdownTextfieldNode'
import DropdownTextfieldConfig from './DropdownTextfieldConfig'

registerNodeType({
  type: 'DROPDOWN_TEXT_FIELD',
  label: 'Dropdown + Text',
  icon: ICONIFY.DROPDOWN_TEXT_FIELD,
  color: '#8D6E63',
  hasOptions: true,
  excludeFields: ['inputMode', 'inputRegex'],
  defaults: { answerOptionList: null },
  nodeComponent: DropdownTextfieldNode,
  configComponent: DropdownTextfieldConfig,
})
